'use client';
import { useEffect } from 'react';
import api from '@/lib/api';
import { useAuthStore } from '@/store/auth.store';

// Авто-вход при открытии сайта как Telegram Mini App.
// Определяем запуск по хэшу #tgWebAppData, подгружаем SDK Telegram
// и обмениваем подписанный initData на обычную cookie-сессию.
export default function TelegramMiniApp() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const w = window as any;
    const launchedFromTg =
      window.location.hash.includes('tgWebAppData') ||
      !!w.Telegram?.WebApp?.initData;
    if (!launchedFromTg) return;

    const onReady = async () => {
      const webApp = w.Telegram?.WebApp;
      if (!webApp) return;
      webApp.ready();
      webApp.expand();
      const initData: string = webApp.initData || '';
      if (!initData) return;
      // Уже залогинены cookie-сессией — ничего не делаем
      if (useAuthStore.getState().user) return;
      try {
        const res = await api.post('/telegram/webapp-auth', { initData });
        useAuthStore.getState().setUser(res.data.data.user);
        // Перезагрузка: initAuth мог параллельно получить 401 без cookie и
        // сбросить пользователя; после reload сессия читается из cookie штатно
        window.location.reload();
      } catch {
        // Telegram не привязан или подпись не прошла — остаёмся гостем
      }
    };

    if (w.Telegram?.WebApp) {
      onReady();
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://telegram.org/js/telegram-web-app.js';
    script.async = true;
    script.onload = onReady;
    document.head.appendChild(script);
  }, []);

  return null;
}
